import { render, staticRenderFns } from "./InclusaoOcorrenciaForm.vue?vue&type=template&id=db7444aa"
import script from "./InclusaoOcorrenciaForm.vue?vue&type=script&lang=js"
export * from "./InclusaoOcorrenciaForm.vue?vue&type=script&lang=js"
import style0 from "./InclusaoOcorrenciaForm.vue?vue&type=style&index=0&id=db7444aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports